import { Box } from '@mui/material';
import { FlatOption } from 'pages/AuditLogs/types';
import { textWithEllipsisStyle } from 'utilities';

const GroupHeaderContent = ({ option, onClick }: { option: FlatOption; onClick: () => void }) => (
  <Box
    title={option.label}
    onClick={onClick}
    sx={{
      fontWeight: 600,
      padding: '8px 16px',
      cursor: 'pointer',
      backgroundColor: '#999',
      '&:hover': {
        backgroundColor: '#777',
      },
    }}>
    <Box
      component="span"
      sx={{
        ...textWithEllipsisStyle,
        display: 'block',
        width: '100%',
      }}>
      {option.label}
    </Box>
  </Box>
);

export default GroupHeaderContent;
